import { View } from '../base/View';
import { ensureElement } from '../../utils/utils';
export class CardView extends View {
    constructor(container, actions) {
        super(container);
        this._category = ensureElement('.card__category', container);
        this._title = ensureElement('.card__title', container);
        this._image = ensureElement('.card__image', container);
        this._price = ensureElement('.card__price', container);
        this._button = container.querySelector('.button') || container;
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            this._button.addEventListener('click', actions.onClick);
        }
    }
    set category(value) {
        this.setText(this._category, value);
    }
    get title() {
        return this._title.textContent || '';
    }
    set title(value) {
        this.setText(this._title, value);
    }
    set image(value) {
        this.setImage(this._image, value, this.title);
    }
    set price(value) {
        this.setInnerHTML(this._price, value);
    }
    set categoryModifier(value) {
        this._category.classList.add(`card__category_${value}`);
    }
}
